
import {logErrorToSentry} from "../utils/errors/logErrorToSentry";
import {cacheManager} from "./cache/CacheManager";
import type {AppState} from "@stores/AppState";


import {MODALS} from "../ui/screens/modals/modal-names";
import {HOTKEYS_SCOPE, setScope} from "../utils/hotkeys";
import {updateCurrentUserWithCognito} from "../actions/clientUser/user";
import {initSupportChat} from "./initSupportChat";
import {logout} from "../actions/app/logout";



let isProcessingInitState = false;


export async function initStateAuto(appState: AppState, updateNameFields?: any, skipModalHandling = false) {
    try {
        if (isProcessingInitState) {
            return;
        }
        isProcessingInitState = true;
        
        const serviceRegistry = appState.getServiceRegistry();
        const authService = serviceRegistry.getAuthService();
        
        const noAPIRequestUser = await authService.getCurrentAuthUser();
        if (!noAPIRequestUser) {
            appState.routerService.loadPageBasedOnRequestedUrl(); // auth required
            isProcessingInitState = false;
            return;
        }
        const user = await authService.getCurrentUser();

        if (!user) {
            appState.routerService.loadPageBasedOnRequestedUrl(); // auth required
            isProcessingInitState = false;
            return;
        }
        
        // Validate cache for current user session (silently ignore failures)
        try {
            await cacheManager.validateUserSession(user.sub);
        } catch (error) {
            console.warn('Cache validation failed during login (cache will be ignored):', error);
        }
        setScope(HOTKEYS_SCOPE.WORKSPACE);

        const rootStore = appState.rootStore;
        const userState = await appState.initUserState(user);

        initSupportChat(rootStore.currentLocale, userState);

        appState.routerService.loadPageBasedOnRequestedUrl(); // main routing point
        rootStore.setIsReady(true);

        if (updateNameFields) {
            const crudServices = {
                authService: serviceRegistry.getAuthService(),
                dataClientService: serviceRegistry.getDataClientService()
            };
            await updateCurrentUserWithCognito(crudServices, userState, updateNameFields);
        } else if (!userState.user.name && !userState.isCurrentUserOwner) {
            appState.setModal({name: MODALS.FILL_INFO, params: undefined});
        } else if (!skipModalHandling) {
            // Only close modal if not handled externally (e.g., in logIn function)
            appState.setModal(null);
        }

        isProcessingInitState = false;
    } catch (error: unknown) {
        if ((error as any)?.name === "UserUnAuthenticatedException") {
            appState.routerService.loadPageBasedOnRequestedUrl(); // auth required
            isProcessingInitState = false;
            return;
        }
        logErrorToSentry(error as Error);
        await logout(appState, appState.getServiceRegistry().getAuthService());
        Object.keys(localStorage).forEach((key) => {
            if (key.includes("CognitoIdentityServiceProvider")) {
                localStorage.removeItem(key);
            }
        });
        sessionStorage.clear();
        isProcessingInitState = false;
    }
}
